import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';

export interface ChatDeleteEvent { chat: any; event: Event; }

// "Chat history" pop-up (specs/ai-agent-home-redesign US-18), opened by the right-panel card's
// Show button. Rendered from the parent's template so the list stays live; every action is
// handled by the parent.
@Component({
  selector: 'app-agent-chat-history-dialog',
  templateUrl: './agent-chat-history-dialog.component.html',
  styleUrls: ['./agent-chat-history-dialog.component.scss'],
})
export class AgentChatHistoryDialogComponent {
  @Input() agentName = '';
  @Input() chats: any[] = [];
  @Input() currentChatId: any = null;
  @Input() loading = false;
  @Output() openChat = new EventEmitter<any>();
  @Output() deleteChat = new EventEmitter<ChatDeleteEvent>();
  @Output() deleteAll = new EventEmitter<Event>();
  @Output() newChat = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  query = '';

  get filteredChats(): any[] {
    const q = this.query.trim().toLowerCase();
    const chats = this.chats || [];
    return q ? chats.filter(chat => (chat.title || '').toLowerCase().includes(q)) : chats;
  }

  timeAgo(ts: any): string {
    return ts ? moment(ts).fromNow() : '';
  }
}
